import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { FontSizeProvider } from './components/contexts/AccessibilityContext';


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <FontSizeProvider>
    <App />
  </FontSizeProvider>
);
